import React, {useState, useEffect} from 'react';
import styles from '../LandingPage.module.css';
import {useAuth} from '../provider/AuthProvider';
import {useNavigate} from 'react-router-dom';
import {signOut} from "firebase/auth";
import {auth} from '../firebase';
import {startListening} from '../utils/speechRecognition';
import {speak} from '../utils/textToSpeech';
import {callAPI} from '../api/callAPI';
import {Button, Card, Col, Container, Row} from "react-bootstrap";
import Header from "../components/Header";

function LandingPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const canvas = document.getElementById("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const text = "Charlotte";
        const particles = [];
        const colors = [
            "#ffffff", "#ffffff", "#ffffff",      // 3x white
            "#ff0033", "#e60026",                 // 2x red
            "#333333", "#333333",                 // 2x gray (button-match)
            "#daa520", "#f4a460"                  // 2x gold/orange
        ];

        function generateTextCoordinates() {
            const offCanvas = document.createElement("canvas");
            const offCtx = offCanvas.getContext("2d");
            offCanvas.width = canvas.width;
            offCanvas.height = canvas.height;
            offCtx.fillStyle = "white";
            offCtx.textAlign = "center";
            offCtx.textBaseline = "middle";
            offCtx.font = `600 ${Math.floor(canvas.width / 8)}px 'Quicksand', sans-serif`;
            offCtx.fillText(text, canvas.width / 2, canvas.height / 2);
            return offCtx.getImageData(0, 0, canvas.width, canvas.height);
        }

        class Particle {
            constructor(x, y, tx, ty, color) {
                this.angle = Math.random() * Math.PI * 2;
                this.radius = Math.random() * 200 + 100;
                this.spinSpeed = 0.05 + Math.random() * 0.02;
                this.x = x;
                this.y = y;
                this.tx = tx;
                this.ty = ty;
                this.color = color;
                this.size = 1.3 + Math.random() * 0.7;
                this.glow = 0;
            }
            update() {
                this.angle += this.spinSpeed;
                const spiralX = this.radius * Math.cos(this.angle);
                const spiralY = this.radius * Math.sin(this.angle);
                this.x += ((this.tx - this.x) + spiralX) * 0.01;
                this.y += ((this.ty - this.y) + spiralY) * 0.01;
                if (this.radius < 10) this.spinSpeed *= 0.95;
                this.radius *= 0.98;
                this.glow += 0.005;
            }
            draw() {
                const pulse = 0.4 + Math.sin(this.glow * 2) * 0.3;
                ctx.shadowColor = this.color;
                ctx.shadowBlur = 10 * pulse;
                ctx.fillStyle = this.color;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fill();
                ctx.shadowBlur = 0;
            }
        }

        function init() {
            particles.length = 0;
            const imageData = generateTextCoordinates();
            for (let y = 0; y < canvas.height; y += 4) {
                for (let x = 0; x < canvas.width; x += 4) {
                    const index = (y * canvas.width + x) * 4;
                    if (imageData.data[index + 3] > 128) {
                        const startX = -50;
                        const startY = Math.random() * canvas.height;
                        const color = colors[Math.floor(Math.random() * colors.length)];
                        particles.push(new Particle(startX, startY, x, y, color));
                    }
                }
            }
        }

        let frameCount = 0;
        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            for (const p of particles) {
                p.update();
                p.draw();
            }

            const button = document.getElementById('start-button');
            if (button) {
                if (frameCount > 120 && frameCount < 160) {
                    document.querySelector('#start-button').style.transform = 'translate(-50%, -50%) scale(1.05)';
                } else {
                    document.querySelector('#start-button').style.transform = 'translate(-50%, -50%) scale(1)';
                }

                frameCount++;
                requestAnimationFrame(animate);
            }

        }

        window.addEventListener("resize", () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            init();
        });

        document.fonts.ready.then(() => {
            init();
            animate();
        });
    });



    return (
        <>
            <canvas id="canvas"></canvas>
            <Button id="start-button" className={` ${styles.startButton} custom-glow`}   onClick={ () => navigate("/login")}>Let's Begin</Button>
        </>

    );
}

export default LandingPage;